<template>
    <div>
        <div class=" py-2 pl-2 flex incorporated items-center gap-4">
            <img src="../../../../../../../../../../../../assets/images/settings/clue icon.svg" alt="" srcset="">
            <p class="text-[14px] font-bold text-[#383F51]">Upload a JPG, JPEG, PNG, or PDF file only.</p>
        </div>
        <form class="mt-4">
            <div class="flex gap-6">
                <div class="flex-1 ">
                    <label for="">Incorporation Name</label>
                    <input type="text" placeholder="Enter" v-model="kyc.incorporationName">
                </div>
                <div class="flex-1 ">
                    <label for="">RC Number</label>
                    <input type="text" placeholder="Enter" v-model="kyc.rcNumber">
                </div>
                <div class="flex-1 ">

                    <label for="">Certificate of Incorporation</label>
                    <input ref="certificateOfIncorporation" type="file" style="display: none;" accept="image/*"
                        @change="onFileSelected">
                    <button v-if="!imageUrl.certificateOfIncorporation"
                        @click.prevent="selectImage('certificateOfIncorporation')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.certificateOfIncorporation" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.certificateOfIncorporation }}</p>
                        <img @click.prevent="removeImage(imageUrl.certificateOfIncorporation, 'certificateOfIncorporation')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
            </div>
            <div class="flex gap-6 mt-4 mb-4">
                <div class="flex-1 ">
                    <label for="">Memorandum & Article of Association</label>
                    <input ref="memat" type="file" style="display: none;" accept="image/*" @change="onFileSelected">
                    <button v-if="!imageUrl.memat" @click.prevent="selectImage('memat')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.memat" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.memat }}</p>
                        <img @click.prevent="removeImage(imageUrl.memat, 'memat')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
                <div class="flex-1 ">
                    <label for="">Form C.A.C 1.1</label>
                    <input ref="formCAC" type="file" style="display: none;" accept="image/*" @change="onFileSelected">
                    <button v-if="!imageUrl.formCAC" @click.prevent="selectImage('formCAC')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.formCAC" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.formCAC }}</p>
                        <img @click.prevent="removeImage(imageUrl.formCAC, 'formCAC')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
                <div class="flex-1 ">
                    <label for="">Status Report</label>
                    <input ref="statusReport" type="file" style="display: none;" accept="image/*"
                        @change="onFileSelected">
                    <button v-if="!imageUrl.statusReport" @click.prevent="selectImage('statusReport')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.statusReport" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.statusReport }}</p>
                        <img @click.prevent="removeImage(imageUrl.statusReport, 'statusReport')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
            </div>
            <div class="flex gap-6">
                <div class="flex-1 ">
                    <label for="">Regulatory License (NIPOST)</label>
                    <input ref="regulatoryLicense" type="file" style="display: none;" accept="image/*"
                        @change="onFileSelected">
                    <button v-if="!imageUrl.regulatoryLicense" @click.prevent="selectImage('regulatoryLicense')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.regulatoryLicense" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.regulatoryLicense }}</p>
                        <img @click.prevent="removeImage(imageUrl.regulatoryLicense, 'regulatoryLicense')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
                <div class="flex-1 ">
                    <label for="">Tax Identification Number</label>
                    <input type="text" placeholder="Enter" v-model="kyc.tin">
                </div>
                <div class="flex-1 ">
                    <label for="">Tax Identification Document (Optional)</label>
                    <input ref="tid" type="file" style="display: none;" accept="image/*" @change="onFileSelected">
                    <button v-if="!imageUrl.tid" @click.prevent="selectImage('tid')"
                        class="flex justify-between items-center">
                        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                        <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg"
                            alt="" srcset="">
                    </button>
                    <button v-if="imageUrl.tid" class=" flex justify-between items-center">
                        <img width=""
                            src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
                            alt="Selected Image" />
                        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.tid }}</p>
                        <img @click.prevent="removeImage(imageUrl.tid, 'tid')"
                            src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt=""
                            srcset="">
                    </button>
                </div>
            </div>
            <div class="next-submit flex justify-end mt-4">
                <button @click="goToRegisteredAddress"
                    :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
                    Next
                </button>
            </div>
        </form>
    </div>
</template>

<script>

export default {

    props: {
        selected: String,
    },


    data() {
        return {
            fileType: '',
            imageUrl: {
                certificateOfIncorporation: null,
                memat: null,
                formCAC: null,
                statusReport: null,
                regulatoryLicense: null,
                tid: null
            },
            kyc: {
                incorporationName: '',
                rcNumber: "",
                certificateOfIncorporation: null,
                memat: null,
                formCAC: null,
                statusReport: null,
                regulatoryLicense: null,
                tin: "",
                tid: null
            },
        };
    },
    
    mounted() {
        const storedData = localStorage.getItem('kycData');

        if (storedData) {
        const parsedData = JSON.parse(storedData);
        this.kyc.incorporationName = parsedData?.data?.org?.companyKYC?.businessInfo?.businessName;
        this.kyc.rcNumber = parsedData?.data?.org?.companyKYC?.businessInfo?.rcNumber;
        this.kyc.tin = parsedData?.data?.org?.companyKYC?.businessInfo?.taxId;
        this.imageUrl.certificateOfIncorporation = parsedData?.data?.org?.companyKYC?.documents?.certificateOfRegistration?.documentUrl.slice(0, 30) + '...';
        this.imageUrl.tid = parsedData?.data?.org?.taxDocuments?.[0]?.documentUrl.slice(0, 30) + '...';
        this.kyc.tid = parsedData?.data?.org?.taxDocuments?.[0]?.documentUrl.slice(0, 30) + '...';
        this.imageUrl.memat = parsedData?.data?.org?.companyKYC?.documents?.memorandumAndArticles?.documentUrl;
        this.imageUrl.formCAC = parsedData?.data?.org?.companyKYC?.documents?.formCAC11?.documentUrl;
        this.imageUrl.statusReport = parsedData?.data?.org?.companyKYC?.documents?.statusReport?.documentUrl;
        this.imageUrl.regulatoryLicense = parsedData?.data?.org?.companyKYC?.documents?.regulatoryLicense?.documentUrl;
        this.kyc.regulatoryLicense = parsedData?.data?.org?.companyKYC?.documents?.regulatoryLicense?.documentUrl.slice(0, 30) + '...';
        this.kyc.statusReport = parsedData?.data?.org?.companyKYC?.documents?.statusReport?.documentUrl.slice(0, 30) + '...';
        this.kyc.formCAC = parsedData?.data?.org?.companyKYC?.documents?.formCAC11?.documentUrl.slice(0, 30) + '...';
        this.kyc.memat = parsedData?.data?.org?.companyKYC?.documents?.memorandumAndArticles?.documentUrl.slice(0, 30) + '...';
        this.kyc.certificateOfIncorporation = parsedData?.data?.org?.companyKYC?.documents?.certificateOfRegistration?.documentUrl.slice(0, 30) + '...';
        
        }
    },

    computed: {
        buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },

        isFormValid() {
            return (
                this.kyc.incorporationName.trim() &&
                this.kyc.rcNumber.trim() &&
                this.imageUrl.certificateOfIncorporation &&
                this.imageUrl.memat &&
                this.imageUrl.formCAC &&
                this.imageUrl.statusReport &&
                this.imageUrl.regulatoryLicense &&
                this.selected === 'Incorporated' &&
                this.kyc.tin.trim()
            );
        }
    },

    methods: {
        goToRegisteredAddress(e) {
            e.preventDefault();
            if (this.isFormValid) {
                this.$emit('openRegisteredAddress', {
                    ...this.kyc,
                    ...this.imageUrl,
                    selected: this.selected
                });
            } else {
                this.generateToast("Form is invalid, cannot proceed.", "error");
                return;
            }
            this.kyc = {
                incorporationName: '',
                rcNumber: "",
                certificateOfIncorporation: null,
                memat: null,
                formCAC: null,
                statusReport: null,
                regulatoryLicense: null,
                tin: "",
                tid: null
            }
            this.imageUrl = {
                certificateOfIncorporation: null,
                memat: null,
                formCAC: null,
                statusReport: null,
                regulatoryLicense: null,
                tid: null
            }
        },

        selectImage(fileType) {
            //   this.$refs.fileInput.click();
            this.fileType = fileType
            const input = this.$refs[fileType];

            if (input) {
                input.click();
            } else {
                this.generateToast("Ref not found: " + fileType, "error");
            }
        },

        onFileSelected(event) {
            const file = event.target.files[0];
            if (file.size > 1048576) {
                this.generateToast("Selected image size is too large. Please upload an image smaller than 1MB!", "error");
                return;
            }

            if (this.fileType === 'certificateOfIncorporation' && file && file.type.startsWith('image/')) {
                this.kyc.certificateOfIncorporation = file.name;
                this.uploadImage(file, 'certificateOfIncorporation');
                this.$forceUpdate();
            } else if (this.fileType === 'memat' && file && file.type.startsWith('image/')) {
                this.kyc.memat = file.name;
                this.uploadImage(file, 'memat');
                this.$forceUpdate();
            } else if (this.fileType === 'formCAC' && file && file.type.startsWith('image/')) {
                this.kyc.formCAC = file.name;
                this.uploadImage(file, 'formCAC');
                this.$forceUpdate();
            } else if (this.fileType === 'statusReport' && file && file.type.startsWith('image/')) {
                this.kyc.statusReport = file.name;
                this.uploadImage(file, 'statusReport');
                this.$forceUpdate();
            } else if (this.fileType === 'regulatoryLicense' && file && file.type.startsWith('image/')) {
                this.kyc.regulatoryLicense = file.name;
                this.uploadImage(file, 'regulatoryLicense');
                this.$forceUpdate();
            } else if (this.fileType === 'tid' && file && file.type.startsWith('image/')) {
                this.kyc.tid = file.name;
                this.uploadImage(file, 'tid');
                this.$forceUpdate();
            } else {
                this.generateToast("Please select a valid image file smaller than 1MB!", "error");
                this.imageUrl = null;
            }
        },

        async uploadImage(image, type) {
            this.isUploadingImage = true;

            const formData = new FormData();
            formData.append("file", image);
            formData.append("upload_preset", "zunt8yrw");

            try {
                const response = await this.$_uploadImage(formData);
                const imageUrl = response?.data?.fileUrl;

                if (!imageUrl) throw new Error("Upload failed: no URL returned");
                if (type === 'certificateOfIncorporation' && imageUrl) {
                    this.imageUrl.certificateOfIncorporation = imageUrl;
                    this.generateToast("Image uploaded", "success");
                } else if (type === 'memat' && imageUrl) {
                    this.imageUrl.memat = imageUrl;
                    this.generateToast("Image uploaded", "success");
                } else if (type === 'formCAC' && imageUrl) {
                    this.imageUrl.formCAC = imageUrl;
                    this.generateToast("Image uploaded", "success");
                } else if (type === 'statusReport' && imageUrl) {
                    this.imageUrl.statusReport = imageUrl;
                    this.generateToast("Image uploaded", "success");
                } else if (type === 'regulatoryLicense' && imageUrl) {
                    this.imageUrl.regulatoryLicense = imageUrl;
                    this.generateToast("Image uploaded", "success");
                } else if (type === 'tid' && imageUrl) {
                    this.imageUrl.tid = imageUrl;
                    this.generateToast("Image uploaded", "success");
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.isUploadingImage = false;
            }
        },

        removeImage(file, fileType) {
            this.fileType = fileType
            if (file === this.imageUrl.certificateOfIncorporation && this.fileType === 'certificateOfIncorporation') {
                this.imageUrl.certificateOfIncorporation = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            } else if (file === this.imageUrl.memat && this.fileType === 'memat') {
                this.imageUrl.memat = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            } else if (file === this.imageUrl.formCAC && this.fileType === 'formCAC') {
                this.imageUrl.formCAC = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            } else if (file === this.imageUrl.statusReport && this.fileType === 'statusReport') {
                this.imageUrl.statusReport = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            } else if (file === this.imageUrl.regulatoryLicense && this.fileType === 'regulatoryLicense') {
                this.imageUrl.regulatoryLicense = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            } else if (file === this.imageUrl.tid && this.fileType === 'tid') {
                this.imageUrl.tid = null
                this.$refs[fileType].value = '';
                this.$forceUpdate();
            }
        },
    }

}
</script>

<style scoped>
.incorporated {
    border-radius: 8px;
    background-color: #F2F7FC;
}

label {
    font-weight: 700;
    font-size: 14px;
    color: #383F51;
}

input {
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 0 2% 2%;
    width: 100%;
}

.next-submit>button {
    background-color: #FCC210;
    border-radius: 2px;
    /* opacity: 0.5;
    cursor: not-allowed; */
}

form>:nth-child(1)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(2)>button,
form>:nth-child(2)>:nth-child(1)>button,
form>:nth-child(3)>:nth-child(1)>button,
form>:nth-child(3)>:nth-child(3)>button {
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 2% 2% 2%;
    width: 100%;
}
</style>
